import { render, staticRenderFns } from "./QuotationSelectModality.vue?vue&type=template&id=6c4c4808&scoped=true"
import script from "./QuotationSelectModality.vue?vue&type=script&lang=js"
export * from "./QuotationSelectModality.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4c4808",
  null
  
)

export default component.exports